import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import {
	useAiIssueCreationEnablementState,
	useIssueCreateSidePanelContext,
} from '../../providers/IssueCreateSidePanelContextProvider.tsx';
import { useBulkCreateContext } from '../../providers/BulkCreateContextProvider.tsx';

import { RainbowLoadingSidebar } from './RainbowLoadingSidebar.tsx';

type IssueCreateAiLoadingSidebarProps = {
	children: React.ReactNode;
};

export const IssueCreateAiLoadingSidebar = ({
	children,
}: IssueCreateAiLoadingSidebarProps): React.JSX.Element => {
	const [{ aiState, pageMode, hasEditPermission }] = useIssueCreateSidePanelContext();
	const [{ isCreatedFromActionItems, isCreatedFromTable }] = useBulkCreateContext();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const aiIssueCreationEnablement = useAiIssueCreationEnablementState();

	const isAiLoading = aiState === 'loading';
	const aiEnablement = aiIssueCreationEnablement?.enablement;

	useEffect(() => {
		if (isAiLoading) {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: 'AI loading state',
					source: 'confluenceHighlightIssueCreate',
					attributes: {
						aiEnablement,
						pageMode,
						hasEditPermission,
						isCreatedFromActionItems,
						isCreatedFromTable,
					},
				},
			}).fire();
		}
	}, [
		createAnalyticsEvent,
		isAiLoading,
		aiEnablement,
		pageMode,
		hasEditPermission,
		isCreatedFromActionItems,
		isCreatedFromTable,
	]);

	return <RainbowLoadingSidebar isShown={isAiLoading}>{children}</RainbowLoadingSidebar>;
};
